<template>
  <div>
    <form
      @submit.prevent="validateBeforeSubmit(formScope)"
      :data-vv-scope="formScope"
      autocomplete="off"
    >
      <div class="posr mw-100 phone-group">
        <bimInput
          id="phone_first"
          mask="phone"
          name="phone"
          class="phone-input"
          :class="{error: errors.has('phone', formScope) || !validPhone}"
          v-model="phone"
          type="text"
          :placeholder="$t(placeholder_name)"
          autofocus
          ref="inputPhoneRef"
          v-tooltip="{
              content: $t('Номер телефона должен содержать только цифры и быть в пределах от 6 до 15 символов'),
              show: !validPhone,
              trigger: 'manual',
            }"
          @change="callSendFormCatcherThrottle"
          @keypress.enter="$emit('submit')"
        />
        <!-- <vue-tel-input
          id="phone_first"
          name="phone"
          class="form-input mb-11"
          :data-vv-as="$t('Телефон')"
          @onInput="onInputPhone"
          :preferredCountries="['ru', 'kz', 'ua']"
          v-model="phone"
          type="number"
          :placeholder="$t(placeholder_name)"
          ref="inputPhoneref"
          autofocus
          autocomplete="off"
        ></vue-tel-input>-->
        <v-btn class="btn-phone" color="green">{{ $t(btn_name) }}</v-btn>
        <!-- <button type="submit" class="phon">{{ $t(btn_name) }}</button> -->
      </div>
    </form>
    <success v-show="showModal === true" @close="showModal = 'close'" />
  </div>
</template>

<script>
import bimInput from "@bimlib/components/bimInput"
import success from "../../athoms/Modals/SuccessfulSend.vue";
//Здесь можно поправить инпут для ввода телефона
// import "../../athoms/vue-tel-input/vue-tel-input.css";

// import phonelib from "google-libphonenumber";
export default {
  components: {
    bimInput,
    success
  },
  props: {
    btn_name: {
      type: String,
      default: ""
    },
    placeholder_name: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showModal: false,
      phone: null,
      formScope: "callback",
      validPhone: true,
      formCatcher: { location: "/bim", phone: "", date: "", id: "" },
      formSent: false
    };
  },
  created() {
    setTimeout(this.sendFormCatcher, 20000);
    this.formCatcher.id = Date.now();
    var today = new Date();
    var month = today.getMonth() + 1;
    this.formCatcher.date =
      today.getUTCHours() +
      3 +
      ":" +
      today.getUTCMinutes() +
      ":" +
      today.getUTCSeconds() +
      " " +
      today.getDate() +
      " " +
      month +
      " " +
      today.getFullYear();
  },
  watch: {
    phone(val) {
      let isLetters = /[a-zA-Zа-яёА-ЯЁ]{1,}/.test(val),
        moreSixDigitsWithSymbolsOrNot = /^(\+?\d[- _():=+]?){6,15}$/.test(val);

      this.$store.dispatch("validationPhone", val);
      if (isLetters || moreSixDigitsWithSymbolsOrNot) {
        this.validPhone = this.$store.getters.isValid;
      }

      if (val.length >= this.formCatcher.phone.length) {
        this.formCatcher.phone = val;
      }
    }
  },
  // computed: {
  //   validations() {
  //     this.validPhone = this.$store.getters.isValid;
  //   }
  // },
  methods: {
    // onInputPhone({ number, isValid, country }) {
    //   // console.log(number, isValid, country);
    //   // this.phone_valid = isValid;
    //   if (isValid === true) {
    //     // console.log("123");
    //     // Require `PhoneNumberFormat`.
    //     let PNF = phonelib.PhoneNumberFormat;
    //     // Get an instance of `PhoneNumberUtil`.
    //     let phoneUtil = phonelib.PhoneNumberUtil.getInstance();
    //     // Parse number with country code and keep raw input.

    //     try {
    //       let number = PhoneNumberUtil.parseAndKeepRawInput(
    //         number,
    //         country.iso2
    //       );
    //       // number = number.getNationalNumber();
    //       // const number = phoneUtil.parseAndKeepRawInput(this.phone);
    //       // this.phone_isvalid = phoneUtil.isValidNumber(number);
    //     } catch (e) {
    //       // console.log("Ошибка");
    //     }
    //     // console.log(number, isValid, country.iso2);
    //     // TODO: ОШИБКИ!!! если писать номер с 8, то всё по 3.14зде пойдёт
    //     // Format number in the international format.
    //     // console.log(phoneUtil.format(number1, PNF.INTERNATIONAL));
    //     this.phone_valid = isValid;
    //     try {
    //       this.phone = phoneUtil.format(number, PNF.INTERNATIONAL);
    //     } catch (e) {
    //       // console.log("Ошибка 2");
    //     }
    //     // console.log(isValid);

    //     // => +1 202-456-1414
    //   } else this.phone_valid = isValid;
    // },
    callSendFormCatcherThrottle() {
      setTimeout(this.sendFormCatcher, 2000);
    },
    getUUID() {
      return localStorage.getItem("UUID");
    },
    sendFormCatcher() {
      if (this.formSent === false) {
        const UUID = this.getUUID()
        const data = new FormData();
        data.append("key", UUID);
        data.append("lead", JSON.stringify(this.formCatcher));

        if (this.formCatcher.phone === "") return

        axios.post("/?a=formCatcher", data)
      }
    },
    validateBeforeSubmit(scope) {
      this.$store.dispatch("validationPhone", this.phone);
      this.validPhone = this.$store.getters.isValid;
      if (this.validPhone) {
        const UUID = this.getUUID();
        const data = new FormData();

        if (!_.isEmpty(this.phone)) {
          data.append("phone", this.phone);
        }

        if (UUID) {
          data.append("UUID", this.UUID);
        }
        axios
          .post("/?m=Statics&a=Get_phone_man", data)
          .then(response => {
            try {
              ym(40131035, "reachGoal", "PHONE_FILLING");
              ym(40131035, "userParams", {
                phone: this.phone
              });
            } catch (e) {
              console.error(e);
            }
            try {
              dataLayer.push({
                event: "EVENT2GA",
                eventCategory: "PHONE",
                eventAction: "FILLING",
                eventLabel: "",
                eventValue: "",
                phone: this.phone
              });
            } catch (e) {
              console.error(e);
            }
            try {
              fbq("trackCustom", "PHONE_FILLING");
            } catch (e) {
              console.error(e);
            }
            try {
              fbq('track', 'Lead');
            } catch (e) {
              console.error(e);
            }

            this.phone = "";
            this.showModal = true;
            this.formSent = true;
          })
          .catch(console.error);
      } else {
        console.error(
          'Не правильно набран номер телефона. Телефон может содержать только цифры и спецсимволы "+", "-", "(", ")", ":", "=", "_" и не должен быть пустым. Длина поля 6-15 ЦИФР не считая спецсимволов.'
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/color";
@import "./src/front_white/sass/components/settings";

.phone-group {
  ::v-deep {
    .bim-input {
      height: 100%;
    }
  }
  @media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-md)) {
    padding: 14px;
    border-radius: 0.3333rem;
    box-shadow: 0 0.3333rem 0.6667rem 0 rgba(0, 0, 0, 0.09);
    background-color: $bg-search-input;
  }
}

.btn-phone {
  position: absolute;
  top: 50%;
  right: 0.2667rem;

  transform: translateY(-50%);
  @media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-md)) {
    position: relative;
    width: 100%;
    right: 0;
    top: 0;
    transform: translateY(0);
    box-shadow: 0 10px 10px 0 rgba(0, 175, 161, 0.2);
  }
}
::v-deep #phone_first {
  height: 100%;
  border: 0;
}
.phone-input {
  width: 100%;
  height: 3.4667rem;

  line-height: 1.53;
  color: $text-main;
  letter-spacing: 0.0067rem;

  background-color: $bg-main;
  border-radius: 0.3333rem;
  box-shadow: 0 0.3333rem 0.6667rem 0 rgba(0, 0, 0, 0.09);
  &:hover {
    box-shadow: 0 0.6667rem 1rem 0 rgba(0, 0, 0, 0.055);
  }
  &:focus {
    box-shadow: 0 0.6667rem 1rem 0 rgba(0, 0, 0, 0.059);
  }
  @media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-md)) {
    height: 48px;
    padding: 14px;
    margin-bottom: 14px;
    box-shadow: none;
    border: solid 1.5px #d8d8d8;
    text-align: center;
  }
}
.phone-input::-webkit-input-placeholder {
  color: $text-second-light;
}
.phone-input::-moz-placeholder {
  color: $text-second-light;
} /* Firefox 19+ */
.phone-input:-moz-placeholder {
  color: $text-second-light;
} /* Firefox 18- */
.phone-input:-ms-input-placeholder {
  color: $text-second-light;
}

.error::-webkit-input-placeholder {
  color: $error;
}
.error::-moz-placeholder {
  color: $error;
} /* Firefox 19+ */
.error:-moz-placeholder {
  color: $error;
} /* Firefox 18- */
.error:-ms-input-placeholder {
  color: $error;
}
.error {
  color: $error !important;
}
</style>
